import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Banner, BannerLinkType } from '../../shared/models/Banner';
import './BannerCarousel.css';

interface BannerCarouselProps {
  banners: Banner[];
  loading?: boolean;
  onBannerClick?: (banner: Banner) => void;
}

export const BannerCarousel: React.FC<BannerCarouselProps> = ({
  banners,
  loading = false,
  onBannerClick,
}) => {
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);

  const handleBannerClick = (banner: Banner) => {
    if (banner.linkType === BannerLinkType.PROJECT && banner.linkUrl) {
      // 跳转到项目详情页
      // TODO: 实现路由跳转
    } else if (banner.linkType === BannerLinkType.EXTERNAL && banner.linkUrl) {
      window.open(banner.linkUrl, '_blank');
    }
    onBannerClick?.(banner);
  };

  if (loading) {
    return <div className="banner-loading">加载中...</div>;
  }

  if (!banners || banners.length === 0) {
    return <div className="banner-empty">暂无 Banner</div>;
  }

  return (
    <div className="banner-section">
      <div className="banner-container">
        <Swiper
          loop={banners.length > 1}
          slidesPerView={1}
          spaceBetween={0}
          allowTouchMove
          simulateTouch
          grabCursor
          observer
          observeParents
          passiveListeners={false}
          touchStartPreventDefault={false}
          nested
          modules={[Autoplay, Pagination]}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          pagination={{ clickable: true }}
          onSlideChange={(swiper: SwiperType) => {
            setCurrentBannerIndex(swiper.realIndex);
          }}
          className="banner-swiper"
        >
          {banners.map((banner) => (
            <SwiperSlide key={banner.id}>
              <div
                className="banner-item"
                onClick={() => handleBannerClick(banner)}
              >
                <img
                  src={banner.imageUrl}
                  alt={banner.title}
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    const placeholder = target.parentElement?.querySelector('.banner-placeholder');
                    if (placeholder) {
                      (placeholder as HTMLElement).style.display = 'flex';
                    }
                  }}
                />
                <div className="banner-placeholder" style={{ display: 'none' }}>
                  <span>暂无图片</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};



